import { Box, Button, Grid, MenuItem, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import ContentLoader from '../../components/ContentLoader';
import useAuth from '../../hooks/useAuth';
import { commonService } from '../../services';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import MaterialReactTable from 'material-react-table';
import CardQuick from '../../components/Card';
import DatePickerField from '../../components/DatePickerField';
const CurrentAccountPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { user } = useAuth();
    const [data, setData] = React.useState([]);
    const [userValue, setUserValue] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    React.useEffect(() => {
        setUserValue(user?.locations[0].id)
        commonService.getCurrentAccount(user.locations[0].id).then((data) => {
            setData(data)
            setIsLoading(false)
        }).catch(() => {
            setIsLoading(false);
        })
    }, [])

    const columns = useMemo(
        () => [
            {
                accessorKey: 'type', //access nested data with dot notation
                header: 'Tipo de Movimento',
            },
            {
                accessorKey: 'description',
                header: 'Descrição',
                enableSorting: false,

                Cell: ({ cell, row }) => (
                    <React.Fragment>
                        <span >{row.original.description}</span><br />
                        <span  >{row.original.details}</span>
                    </React.Fragment>
                ),
            },
            {
                accessorKey: 'amount',
                header: 'Montante',
                enableSorting: false,
                size: 10,

                Cell: ({ cell, row }) => (
                    <React.Fragment>
                        {row.original.sign == '-' ? <span style={{ color: '#ff3333' }} >{row.original.amount}</span> : <span style={{ color: '#4BB543' }} >{row.original.amount}</span>}
                    </React.Fragment>
                ),
            },
            {
                accessorKey: 'balance',
                header: 'Saldo',
                enableSorting: false,
                size: 10,

                Cell: ({ cell, row }) => (
                    <React.Fragment>
                        <span style={{ color: '#4BB543' }} >{row.original.balance}</span>
                    </React.Fragment>
                ),
            },
            {
                accessorKey: 'date_created', //access nested data with dot notation
                header: 'Data',
            }

        ],
        [],
    );
    const onSearch = () => {
        setIsLoading(true)
        commonService.getCurrentAccount(userValue, startDate??'', endDate??'').then((data) => {
            setData(data)
            setIsLoading(false)
        }).catch(() => {
            setIsLoading(false);
        })
    }
    return (
        <React.Fragment>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant='h1' fontWeight={600}>Conta corrente</Typography>
                            <Box mb={2}/>
                            <Typography variant='h3' fontWeight={600}>Saldo: {data?.cc_info?.balance} kz</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack spacing={1}>
                                <TextField
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderRadius: 8,
                                            },
                                        },
                                    }}
                                    select
                                    size="small"
                                    defaultValue=""
                                    variant="outlined"
                                    value={userValue}
                                    onChange={(e) => {
                                        setUserValue(e.target.value)
                                        //Pesquisa Novamente
                                    }}
                                >
                                    {user.locations?.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                    ))}
                                </TextField>

                            </Stack>
                        </Grid>
                        <Grid item xs={1}>
                            <DatePickerField fullWidth label="De" value={startDate} onChange={(e) => {
                                setStartDate(e.target.value)
                            }} />
                        </Grid>
                        <Grid item xs={1}>
                            <DatePickerField fullWidth label="Até" value={endDate} onChange={(e) => {
                                setEndDate(e.target.value)
                            }} />
                        </Grid>
                        <Grid item xs={2}>
                            <Stack direction={'row'} spacing={1}>
                                <Button onClick={() => {
                                    onSearch();
                                }} variant='contained'>Pesquisar</Button>
                                <Button onClick={() => {
                                      setEndDate(null);
                                      setStartDate(null)
                                }} variant='contained'>Limpar</Button>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Box mt={4} />
                </Grid>
                <Grid xs={12}>
                    <CardQuick>
                        <MaterialReactTable
                            initialState={{ density: 'compact' }}
                            columns={columns}
                            data={data?.rows ?? []}
                            enableFullScreenToggle={false}
                            localization={MRT_Localization_PT_BR}
                            enableFilters={false}
                            enableDensityToggle={false}
                            enableColumnFilters={false}
                            enableColumnOrdering={false}
                            enableHiding={true}
                            positionToolbarAlertBanner="bottom"
                            muiTableBodyCellProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTablePaginationProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiBottomToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTopToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTableHeadRowProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTablePaperProps={{ sx: { boxShadow: 'none' } }}
                        />
                    </CardQuick>
                </Grid>
            </Grid>
            <ContentLoader open={isLoading} />
        </React.Fragment>


    )
}

export default CurrentAccountPage;

